var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page__container"},[_c('Header'),_c('div',{staticClass:"page__content"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }